import React, { useContext } from 'react';
import FilterInput from '../../../components/filter-input';

import { id } from '../../../../filters/options/batch-number';
import { AdvancedSearchShipmentContext } from '../../context';
import messages from '../messages';

const BatchNumberFilter = () => {
  const { filters, updateFilter } = useContext(AdvancedSearchShipmentContext);

  return <FilterInput filters={filters} id={id} labelMessage={messages.batchNumber} updateFilter={updateFilter} />;
};

export default BatchNumberFilter;
